<ng-container>
    <div *ngIf="routeStation" (click)="openDeChannels(routeStation)">
        <div class="d-flex flex-column m-2">
            <span class="text-bg-danger ps-2">Name: {{ routeStation.routeStation.name}} </span>
            <span class="text-center "> SAM ID: {{ routeStation.routeStation.samId}} </span>
        </div>

        <div *ngFor="let kanal of sortedChannels">
            <!-- Typ + Sensortyp (via Radar-Verknüpfung) + Fahrspur zentral über getChannelLabel -->
            <div *ngIf="label(kanal) as lbl">
                <div class="d-flex bg-light m-2 border border-2 border-secondary">
                    <div class="d-flex justify-content-between bg-light m-2 w-100 align-items-center">
                        <div class="d-flex flex-column" style="max-width: 140px; overflow-wrap: anywhere;">
                            <span>{{ lbl.name }}</span>
                            <span *ngIf="lbl.sublabel">{{ lbl.sublabel }}</span>
                        </div>
                        <div> <span> Line: {{kanal.line ? kanal.line : 'null' }}</span></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>